import { createConfig, configureChains } from "wagmi";
import { polygon, polygonMumbai, sepolia, mainnet } from "wagmi/chains";
import { publicProvider } from "wagmi/providers/public";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";
import { CoinbaseWalletConnector } from "wagmi/connectors/coinbaseWallet";
import { MetaMaskConnector } from "wagmi/connectors/metaMask";
import { infuraProvider } from "wagmi/providers/infura";

import { envChains } from "utils/helper";


const supportedChain = [];
if (envChains.includes(80001)) {
  supportedChain.push(polygonMumbai);
}
if (envChains.includes(11155111)) {
  supportedChain.push(sepolia);
}
if (envChains.includes(137)) {
  supportedChain.push(polygon);
}
if (envChains.includes(1)) {
  supportedChain.push(mainnet);
}

const { chains, publicClient,webSocketPublicClient } = configureChains(supportedChain, [
  infuraProvider({
    apiKey: process.env.REACT_APP_INFURA_KEY,
  }),
  publicProvider(),
]);

export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ chains }),
    new WalletConnectConnector({
      chains,
      options: {
        projectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID,
      },
    }),
    new CoinbaseWalletConnector({ chains }),
  ],
  publicClient,
  webSocketPublicClient,
});
